import * as React from 'react'

function SvgPlayerPlay(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M19.433 12.972L5.719 20.847a1.153 1.153 0 01-1.563-.405A1.112 1.112 0 014 19.875V4.125C4 3.504 4.512 3 5.143 3c.202 0 .4.053.576.153l13.714 7.875a1.116 1.116 0 010 1.944z"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default SvgPlayerPlay
